var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-green-200"})
}
var staticRenderFns = []

export { render, staticRenderFns }